<template>
  <b-input-group 
    prepend="Document" 
    style="z-index: 10"
  >
    <b-file
      v-model="nieuwdocument.document"
      accept=".pdf,.docx,.xlsx"
      placeholder="Kies bestand of sleep hier in..."
      drop-placeholder="Laat maar los..."
      browse-text="Kies bestand"
    />
        
    <b-button 
      v-if="nieuwdocument.document"
      style="z-index: 100" 
      @click="upload()"
    >
      <b-spinner 
        v-if="busy" 
        :small="true" 
        size="sm" 
        role="status"
      />
      {{ busy ? 'Uploading...' : 'Secure uploaden' }}
    </b-button>
  </b-input-group>
</template>
<script>
import { serviceMixin } from "@/mixins/serviceMixin.js";

export default {
    name: 'SecureUpload',
    mixins: [serviceMixin],
    props: {
      endpoint: {
        type: String,
        default: null
      },
      subfolder: {
        type:String,
        default: ''
      }
    },
    data() {
        return {
          busy: false,
          nieuwdocument: {
            document: null,
            documentType: 0,
            documentStatus: "Ter controle",
            documentTonen: false,
            soortOnderhoud: "Correctief",
            verzenddatum: null,
            bedrag: 0,
            kenmerk: '',
            opmerking: 'Ter beoordeling test',
            vanRelatie: null,
            aanRelatie: null,
            aanContactpersoon: null
          },
        }
    },
    computed: {
        uploadAPIPath: function () {
            return this.endpoint;
        },
    },
    methods: {
      upload() {
        this.busy = true;
        var vm = this;
        var formdata = new FormData();
        formdata.append("file_content", this.nieuwdocument.document);
        formdata.append("file_name", this.nieuwdocument.document.name);
        formdata.append("subfolder", this.subfolder)

        // doc fields
        formdata.append("documentType",this.nieuwdocument.documentType);
        formdata.append("documentStatus",this.nieuwdocument.documentStatus);
        formdata.append("documentTonen",this.nieuwdocument.documentTonen);
        formdata.append("soortOnderhoud",this.nieuwdocument.soortOnderhoud);
        formdata.append("verzenddatum",this.nieuwdocument.verzenddatum);
        formdata.append("bedrag",this.nieuwdocument.bedrag);
        formdata.append("kenmerk",this.nieuwdocument.kenmerk);
        formdata.append("opmerking",this.nieuwdocument.opmerking);
        formdata.append("vanRelatie",this.nieuwdocument.vanRelatie);
        formdata.append("aanRelatie",this.nieuwdocument.aanRelatie);
        formdata.append("aanContactpersoon",this.nieuwdocument.aanContactpersoon);
    
        this.postMultipart(this.uploadAPIPath, formdata)
          .then(function (response) {
            console.log(response.data);
            vm.$emit('file-uploaded', response.data);
            // vm.uploadResponse = response.data
          })
          .catch(function (error) {
            // vm.uploadResponse = error
            console.log(error);
          })
          .finally(() => { 
            vm.busy = false 
          });
      },
    }
}
</script>